import { generatePath } from 'react-router-dom';

import { PaymentMethodsDto } from 'common/api/autogenerated/client-area';

import { APPLE_PAY_METHOD_ID } from 'common/components/DepositButton/DepositButtons/constants';

import { getPaymentTypes, getWalletConfiguration } from 'views/wallet-new/redux/wallet.api';

import { routes } from 'routes/routes.constants';

import bankTransferImage from '../../../assets/images/payment-method-bank-transfer.png';
import creditCardImage from '../../../assets/images/payment-method-card.png';
import { AlternativeFiatPaymentMetod, FiatPaymentMetod } from './types';

export const convertPaymentMethodsFromServer = (
  response: PaymentMethodsDto,
  currency: string,
  cashierUrl: string,
  params?: URLSearchParams,
) => {
  const fiat: FiatPaymentMetod[] = [];
  const alternative: AlternativeFiatPaymentMetod[] = [];

  if (response.alternative && response.alternative.paymentSystems?.length) {
    response.alternative.paymentSystems.forEach((current) => {
      if (!current.id) return;

      const query = new URLSearchParams(params);

      const url = generatePath(routes.getDepositPage(), { currency });
      const externalUrl = new URL(cashierUrl);

      query.set('method', current.id);
      query.set('currency', currency);

      params?.forEach((value, key) => query.set(key, value));

      const method: AlternativeFiatPaymentMetod = {
        label: current.publicTitle || '',
        image: current.image || '',
        id: current.id || '',
        name: current.name || '',
        url: `${url}?${query.toString()}`,
        external: false,
        type: 'fiat',
      };

      if (current.name === APPLE_PAY_METHOD_ID) {
        query.forEach((value, key) => externalUrl.searchParams.set(key, value));
        method.url = externalUrl.toString();
        method.external = true;
      }

      alternative.push(method);
    }, []);
  }

  if (response.creditCard && response.creditCard.enabled) {
    fiat.push({
      url: `${generatePath(routes.getDepositPage(), { currency })}?${params}`,
      label: 'card',
      name: 'card',
      id: 'deposit',
      type: 'fiat',
      external: false,
      image: creditCardImage,
    });
  }
  if (response.wireTransfer && response.wireTransfer.enabled) {
    fiat.push({
      url: `${generatePath(routes.getWireTransferPage(), {
        currency,
      })}?${params}`,
      label: 'bank',
      name: 'bank',
      id: 'wireTransfer',
      type: 'fiat',
      external: false,
      image: bankTransferImage,
    });
  }

  return { alternative, fiat };
};

export const requestPaymentMethods = (currency: string) => getPaymentTypes(currency);

export const requestWalletConfiguration = () => getWalletConfiguration();
